import React, { useEffect, useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { useAIEventsInstrumentation } from '@atlassian/ai-analytics';

import { useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { CardTemplate } from '../../constants';
import { useAIAnswerContext } from '../ai-answer-context';
import { NLPSearchResultFormat } from '../types';

import {
	AIAnswerError,
	JsonResultComponent,
	PlaintextResultComponent,
	RenderedResultComponent,
} from './ai-answer-result';
import { AIAnswerBodyWrapper, AIAnswerErrorWrapper } from './styled';

const AIAnswerResult = () => {
	const { commonAttributes } = useAIAnswerContext();
	const { trackAIResultView } = useAIEventsInstrumentation();
	const { fireSAINUsageEvent } = useSAINUsageCriteriaMet();
	const { answerFormat } = commonAttributes;

	useEffect(() => {
		fg('kd_enable_new_usage_tracking')
			? fireSAINUsageEvent({ commonAttributes })
			: trackAIResultView();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const AIAnswerResultComponent = useMemo(() => {
		switch (answerFormat) {
			case NLPSearchResultFormat.ADF:
			case NLPSearchResultFormat.MARKDOWN:
				return RenderedResultComponent;
			case NLPSearchResultFormat.JSON:
				return JsonResultComponent;
			case NLPSearchResultFormat.PLAINTEXT:
			default:
				return PlaintextResultComponent;
		}
	}, [answerFormat]);
	return <AIAnswerResultComponent />;
};

export const AIAnswerBody = () => {
	const { isAnswered, hasError, isReadingAids, cardTemplate } = useAIAnswerContext();
	return (
		<AIAnswerBodyWrapper isReadingAids={isReadingAids && cardTemplate === CardTemplate.DEFAULT}>
			{isAnswered && !hasError ? (
				<AIAnswerResult />
			) : hasError ? (
				<AIAnswerErrorWrapper>
					<AIAnswerError />
				</AIAnswerErrorWrapper>
			) : null}
		</AIAnswerBodyWrapper>
	);
};
